import React, { useState, useCallback, Fragment, useEffect } from 'react';
import { ToggleButton, ToggleButtonGroup, Box, Grid, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';
import { ruleList } from './RuleStatic';
import RulePannel from './RulePannel';
import RuleList from './RuleList';
import BlockViewer from './BlockViewer';

const BlockEditor = props => {
    const [sketchUdid, setSketchUdid] = React.useState(null)
    const [type, setType] = React.useState('targetComponent')
    const [rule, setRule] = React.useState(ruleList[0])
    const [ruleInstance, setRuleInstance] = React.useState(null)
    const [ruleInstanceList, setRuleInstanceList] = React.useState([])
    const [ruleInstanceShowList, setRuleInstanceShowList] = React.useState([])
    const [targetNode, setTargetNode] = React.useState(null)
    const [change, setChange] = React.useState(1)

    const handleType = (event, newType) => {
        if (!newType || newType == type)
            return
        setType(newType);
        let rule = ruleList.filter(m => m.type == newType)[0]
        setRule(rule)

        if (newType == 'targetComponent')
            setRuleInstanceShowList(ruleInstanceList)
        else
            setRuleInstanceShowList(ruleInstanceList.filter(m => m.type == newType))

        setRuleInstance(null)
    };

    const updateRule = () => {
        if (props.id) {
            setChange(change + 1)
            client.request_get(`/api/rule/list/${props.id}`).then(ruleInstanceList => {
                setRuleInstanceList(ruleInstanceList)
                if (type == 'targetComponent')
                    setRuleInstanceShowList(ruleInstanceList)
                else
                    setRuleInstanceShowList(ruleInstanceList.filter(m => m.type == type))

                let targetComponent = ruleInstanceList.filter(m => m.type == 'targetComponent')
                if (targetComponent.length > 0) {
                    setTargetNode(targetComponent[0].select1)
                }
            })
        }
    }

    const updateBlock = () => {
        if (props.id) {
            setChange(change + 1)
            client.request_get(`/block/${props.id}`).then(res => {
                setSketchUdid(res.sketch_udid)
            })
        }
    }

    const handleEdit = (row) => {
        setRule(ruleList.filter(m => m.type == row.type)[0])
        setType(row.type)
        setRuleInstance(row)
    }

    useEffect(() => {
        // console.log('props.id', props.id)
        updateBlock();
        updateRule();
    }, [props.id])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4} style={{ overflow: 'auto' }}>
                <BlockViewer block_id={props.id} change={change} clickable={true} />
            </Grid>
            <Grid item xs={12} md={8} lg={8} style={{ overflow: 'auto' }}>
                {props.learning == true && <Box>
                    <Box>
                        <ToggleButtonGroup
                            value={type}
                            exclusive
                            onChange={handleType}
                        >
                            {targetNode && ruleList.slice(1, 8).map(m => (
                                <ToggleButton key={m.type} value={m.type}>
                                    {m.icon()}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                </Box>}
                {(!props.learning || props.learning == false) && <Box>
                    <Box>
                        <ToggleButtonGroup
                            value={type}
                            exclusive
                            onChange={handleType}
                        >
                            {targetNode && ruleList.slice(0, 14).map(m => (
                                <ToggleButton key={m.type} value={m.type}>
                                    {m.icon()}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                    <Box mt={1}>
                        <ToggleButtonGroup
                            value={type}
                            exclusive
                            onChange={handleType}
                        >
                            {targetNode && ruleList.slice(14, ruleList.length).map(m => (
                                <ToggleButton key={m.type} value={m.type}>
                                    {m.icon()}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                </Box>}
                {sketchUdid && <Box style={{ overflow: 'auto' }}>
                    <RulePannel block_id={props.id} rule={rule} ruleInstance={ruleInstance} changed={updateRule}
                        sketchUdid={sketchUdid} targetNode={targetNode}
                    />
                </Box>}
            </Grid>
            <Grid item xs={12} style={{ overflow: 'auto' }}>
                <Box >
                    <RuleList id={props.id} list={ruleInstanceShowList} changed={updateRule} edit={handleEdit} />
                </Box>
            </Grid>
        </Grid>
    )
}

export default BlockEditor;